// openapi/services.gen.ts
import { createClient, createConfig } from "@hey-api/client-fetch";
var client = createClient(createConfig());
var plan = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/v5/plan"
  });
};
var oneToMany = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/v1/one-to-many"
  });
};
var oneToAll = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/v1/one-to-all"
  });
};
var reverseGeocode = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/v1/reverse-geocode"
  });
};
var geocode = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/v1/geocode"
  });
};
var trip = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/v5/trip"
  });
};
var stoptimes = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/v5/stoptimes"
  });
};
var trips = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/v5/map/trips"
  });
};
var initial = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/v1/map/initial"
  });
};
var stops = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/v1/map/stops"
  });
};
var levels = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/v1/map/levels"
  });
};
var rentals = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/v1/rentals"
  });
};
var transfers = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/debug/transfers"
  });
};

export {
  client,
  plan,
  oneToMany,
  oneToAll,
  reverseGeocode,
  geocode,
  trip,
  stoptimes,
  trips,
  initial,
  stops,
  levels,
  rentals,
  transfers
};
